module.exports = __webpack_public_path__ + "img/France.3c59a185.svg";